import './App.css';
import { useEffect } from "react";
import { useLocation, Routes, Route } from "react-router-dom";
import { Helmet } from 'react-helmet'; 
import HeaderFile from "./components/HeaderFile/HeaderFile";
import Home from "./components/Home/Home";
import Skills from './components/About/About';
import Pursuits from './components/Pursuits/Pursuits';
import Portfolio from './components/Portfolio/Portfolio';
import Resume from './components/Resume/Resume';
import Contact from './components/Contact/Contact';
import ContactPage from './components/ContactPage/ContactPage';
import Footer from './components/Footer/Footer';

function App() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Find the element matching the hash and scroll into view
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="App">
      <Helmet>
        <title>Pravin Kanth</title>
        <meta name="description" content="Explore my portfolio, resume and pursuits. Contact me for collaboration and opportunities." />
        <meta name="keywords" content="portfolio, resume, full stack developer, finance, Pravin Kanth" />
      </Helmet>
      <Routes>
        <Route path="/" element={<AppRoutes />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <div><Footer /></div>
    </div>
  );
}

function AppRoutes() {
  return (
    <>
      <HeaderFile />
      <Home />
      <Skills />
      <Pursuits />
      <Portfolio />
      <Resume />
      <Contact />
    </>
  );
}

export default App;
